import { render } from "./DiabetesOne.vue?vue&type=template&id=779f2384&scoped=true"
import script from "./DiabetesOne.vue?vue&type=script&lang=js"
export * from "./DiabetesOne.vue?vue&type=script&lang=js"

import "./DiabetesOne.vue?vue&type=style&index=0&id=779f2384&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779f2384"]])

export default __exports__